// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCotsHWQ48x4qkqB6uAv-r4yktuhz5LgPU",
  authDomain: "fir-authentication-ca637.firebaseapp.com",
  databaseURL: "https://fir-authentication-ca637-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "fir-authentication-ca637",
  storageBucket: "fir-authentication-ca637.firebasestorage.app",
  messagingSenderId: "591229707599",
  appId: "1:591229707599:web:4163d0bbdbee6b241b913a",
  measurementId: "G-WW0FXJSWBR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth();
export const db = getFirestore(app);
export default app;
